module.exports = __webpack_public_path__ + "static/img/role.fd3d4d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/sy/role.png
// module id = QeNX
// module chunks = 7